import {baseUrl} from'../config';

export const usersController ={
    GetAllUsers:baseUrl+'/api/user'
}